const MIC_ERROR = {
  UNKNOWN: 0,
  NO_SSL: 9,
  MAC_OS_BLOCK: 8,
  NO_PERMISSION: 7,
  DEVICE_NOT_FOUND: 6,
};

export default { MIC_ERROR };
